(() => {
  'use strict';

  const encouragements = [
    'Let’s start with your plans.',
    'Now, set the mood.',
    'Your favorite shape says a lot.',
    'Color makes the feeling.',
    'Finish your personal edit.'
  ];

  function initStyleFinder(root) {
    if (!root || root.dataset.styleFinderReady === 'true') return;
    root.dataset.styleFinderReady = 'true';

    const shell = root.querySelector('[data-sp-quiz-shell]');
    const form = root.querySelector('[data-sp-quiz-form]');
    const steps = Array.from(root.querySelectorAll('[data-sp-quiz-step]'));
    const nextButton = root.querySelector('[data-sp-next]');
    const nextLabel = root.querySelector('[data-sp-next-label]');
    const backButton = root.querySelector('[data-sp-back]');
    const progress = root.querySelector('[data-sp-progress]');
    const stepLabel = root.querySelector('[data-sp-step-label]');
    const encouragement = root.querySelector('[data-sp-encouragement]');
    const percent = root.querySelector('[data-sp-percent]');
    const error = root.querySelector('[data-sp-error]');
    const loading = root.querySelector('[data-sp-loading]');
    const results = root.querySelector('[data-sp-results]');
    const resultPanels = Array.from(root.querySelectorAll('[data-sp-result]'));
    const retake = root.querySelector('[data-sp-retake]');

    if (!shell || !form || !steps.length || !nextButton || !results) return;

    let currentStep = 0;
    let loadingTimer;

    function updateStep({ focus = false } = {}) {
      steps.forEach((step, index) => {
        const active = index === currentStep;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });

      const complete = Math.round(((currentStep + 1) / steps.length) * 100);
      progress.style.width = `${complete}%`;
      stepLabel.textContent = `Question ${currentStep + 1} of ${steps.length}`;
      percent.textContent = `${complete}%`;
      encouragement.textContent = encouragements[currentStep] || '';
      backButton.hidden = currentStep === 0;
      if (nextLabel) nextLabel.textContent = currentStep === steps.length - 1 ? 'See my style' : 'Continue';
      error.hidden = true;

      if (focus) {
        window.requestAnimationFrame(() => steps[currentStep].querySelector('legend')?.focus?.());
      }
    }

    function getSelected(step) {
      return step.querySelector('input[type="radio"]:checked');
    }

    function scoreQuiz() {
      const scores = { statement: 0, romantic: 0, getaway: 0, offduty: 0 };
      const selections = steps.map((step) => getSelected(step)).filter(Boolean);

      selections.forEach((input, index) => {
        const key = input.dataset.score;
        if (Object.prototype.hasOwnProperty.call(scores, key)) {
          scores[key] += index === 0 ? 2 : 1;
        }
      });

      const firstChoice = selections[0]?.dataset.score || 'statement';
      return Object.keys(scores).reduce((winner, key) => {
        if (scores[key] > scores[winner]) return key;
        if (scores[key] === scores[winner] && key === firstChoice) return key;
        return winner;
      }, firstChoice);
    }

    function buildReason() {
      const labels = steps
        .map((step) => getSelected(step)?.dataset.label)
        .filter(Boolean);

      if (labels.length < 3) return 'Based on the style instincts you shared.';
      return `You chose ${labels[0]}, ${labels[1]}, and ${labels[2]}—a clear direction for your next look.`;
    }

    function revealResult() {
      const winner = scoreQuiz();
      const activeResult = resultPanels.find((panel) => panel.dataset.spResult === winner) || resultPanels[0];

      form.hidden = true;
      root.querySelector('.sp-style-finder__quiz-top').hidden = true;
      root.querySelector('.sp-style-finder__progress').hidden = true;
      loading.hidden = false;

      window.clearTimeout(loadingTimer);
      loadingTimer = window.setTimeout(() => {
        loading.hidden = true;
        results.hidden = false;
        resultPanels.forEach((panel) => { panel.hidden = panel !== activeResult; });
        const reason = activeResult?.querySelector('[data-sp-result-reason]');
        if (reason) reason.textContent = buildReason();
        activeResult?.querySelector('h2')?.focus({ preventScroll: true });
        shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 10 : 850);
    }

    nextButton.addEventListener('click', () => {
      const selected = getSelected(steps[currentStep]);
      if (!selected) {
        error.hidden = false;
        const firstInput = steps[currentStep].querySelector('input[type="radio"]');
        firstInput?.focus();
        return;
      }

      error.hidden = true;
      if (currentStep === steps.length - 1) {
        revealResult();
        return;
      }

      currentStep += 1;
      updateStep();
      shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    backButton.addEventListener('click', () => {
      if (currentStep === 0) return;
      currentStep -= 1;
      updateStep();
      shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) error.hidden = true;
    });

    form.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('input[type="radio"]')) {
        event.preventDefault();
        nextButton.click();
      }
    });

    retake?.addEventListener('click', () => {
      window.clearTimeout(loadingTimer);
      form.reset();
      currentStep = 0;
      results.hidden = true;
      loading.hidden = true;
      resultPanels.forEach((panel) => { panel.hidden = true; });
      form.hidden = false;
      root.querySelector('.sp-style-finder__quiz-top').hidden = false;
      root.querySelector('.sp-style-finder__progress').hidden = false;
      updateStep();
      shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    updateStep();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-sp-style-finder]').forEach(initStyleFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
